import { Skeleton, Title } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";

const TotalListingsTitle = ({ isLoading, total }) => {
  const isMobile = useMediaQuery("(max-width: 992px)");

  if (isLoading) {
    return (
      <Skeleton
        visible={isLoading}
        height={35}
        width={"75%"}
        className={`${isMobile ? "d-none" : "w-75 mb-2"}`}
      />
    );
  }

  if (!total) {
    return null;
  }

  return (
    <Title
      order={isMobile ? 4 : 2}
      className={`font-medium ${isMobile ? "mb-1" : "w-75 mx-3 mb-3"}`}
    >
      {total.toLocaleString("nl-NL")} Vakantiehuizen gevonden
    </Title>
  );
};

export default TotalListingsTitle;
